export default "__VITE_PUBLIC_ASSET__d630ef6c__"